export class WidgetState {

    static isRedirect() {
        return (this.getSessionId() != null);
    }

    static isTicketDownload() {
        return (this.getOrderNumber() != null);
    }

    static getUrlPromoCode() {
        const query = new URL(window.location.href).searchParams;
        return query.get("promoCode");
    }

    static getOrderNumber() {
        const query = new URL(window.location.href).searchParams;
        return query.get("orderNumber");
    }

    static getSessionId() {
        const query = new URL(window.location.href).searchParams;
        return query.get("etasession");
    }
}
